export const NAVIGATION = {
  HomePage: '/',
  Login: '/login',
  dashboard: '/dashboard',
  category: '/question_category',
  question: '/questions',
  download: '/download',
  settings: '/manage_account',
  insight: '/insight',
  managequestions: '/managequestions'
};

export const AUTH_STATUS = {
  Pending: 0,
  Authorized: 1,
  Unauthorized: 2
};

export const STATUS_CODE = {
  Ok: 200,
  Created: 201,
  Deleted: 204,
  Error: 400,
  TokenExpired: 401
};

export const UNAUTHORIZED_MSG = 'You are not authorized to view this application.';

export const ALERT_MESSAGE_TIME = 6000;

export const ALERT_MSG_SEVERITY = {
  SUCCESS: 'success',
  ERROR: 'error'
};
